import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  root: `UrlList`,
  icon: `UrlListIcon`
};

export function useUrlListStyles() {
  const { semanticColors } = useTheme();

  return useMemo(
    () => mergeStyleSets({
      icon: [
        classNames.icon,
        {
          paddingBottom: `6px`,
          marginRight: `5px`,
          color: semanticColors.link
        }
      ]
    }),
    [semanticColors]
  );
}
